// src/CustomMenu.jstummenulerburada_duyuruetkınlıkvb
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  Home,
  Layers,
  Activity,
  Bell,
  Calendar,
  Users,
  LogOut,
  Settings,
  LayoutDashboard, // Ana Sayfa Yönetimi
  Phone, // İletişim
  BarChart2, // Anketler
  MessageSquare, // Geri Bildirim
} from "lucide-react";
import { API_BASE, UPLOAD_BASE, ORIGIN_BASE } from "./config";
import {
  // ... mevcut importlar ...
  QrCode, // QR kod ikonu
} from "lucide-react";

/* ---------- i18n ---------- */
const I18N = {
  tr: {
    home: "Ana sayfa",
    mainCategories: "Ana Kategoriler",
    homepageManagement: "Hakkımızda",
    activities: "Faaliyetler",
    announcements: "Duyurular",
    events: "Etkinlikler",
    contact: "İletişim",
    polls: "Anketler",
    feedback: "Geri Bildirim",
    users: "Kullanıcılar",
    settings: "Ayarlar",
    logout: "Çıkış",
    placeholderLogo: "LOGO",
qrCode: "QR Kod",
  },
  en: {
    home: "Home",
    mainCategories: "Main Categories",
    homepageManagement: "About Us",
    activities: "Activities",
    announcements: "Announcements",
    events: "Events",
    contact: "Contact",
    polls: "Polls",
    feedback: "Feedback",
    users: "Users",
    settings: "Settings",
    logout: "Logout",
    placeholderLogo: "LOGO",
qrCode: "QR Code",
  },
  de: {
    home: "Startseite",
    mainCategories: "Hauptkategorien",
    homepageManagement: "Über uns",
    activities: "Aktivitäten",
    announcements: "Mitteilungen",
    events: "Veranstaltungen",
    contact: "Kontakt",
    polls: "Umfragen",
    feedback: "Rückmeldung",
    users: "Benutzer",
    settings: "Einstellungen",
    logout: "Abmelden",
    placeholderLogo: "LOGO",
qrCode: "QR Code",
  },
};

const getLang = () => {
  const fromApp = (localStorage.getItem("app_lang") || "").toLowerCase();
  const fromLang = (localStorage.getItem("lang") || "").toLowerCase();
  const nav = ((navigator.language || "tr").slice(0, 2) || "tr").toLowerCase();
  const cand = fromApp || fromLang || nav;
  return ["tr", "en", "de"].includes(cand) ? cand : "tr";
};

const t = (lang, key, fallback) => I18N[lang]?.[key] ?? fallback ?? key;
/* ----------------------------------- */

/* -------- Upload URL normalize (AyarlarPage ile aynı mantık) -------- */
const ORIGIN =
  ORIGIN_BASE || (typeof window !== "undefined" ? window.location.origin : "");
const UP_BASE = (UPLOAD_BASE && UPLOAD_BASE.trim()) || "";

function originWithoutPanel(originStr) {
  try {
    const u = new URL(originStr);
    if (u.hostname.startsWith("panel.")) {
      u.hostname = u.hostname.replace(/^panel\./, "");
      return u.origin;
    }
    return u.origin;
  } catch {
    return originStr;
  }
}
function normalizeUploadUrl(raw) {
  if (!raw) return "";
  let u = String(raw).trim();
  u = u.replace(/^http:\/\//i, "https://");
  if (!/^https?:\/\//i.test(u) && !u.startsWith("/")) {
    u = `/uploads/${u}`;
  }
  const strip = (p) =>
    p.replace(/^\/?(upload|uploads)\//i, "").replace(/^\/+/, "");
  try {
    const abs = new URL(u, ORIGIN);
    const filePart = strip(abs.pathname);
    const chosenOrigin = UP_BASE
      ? new URL(UP_BASE, ORIGIN).origin
      : originWithoutPanel(ORIGIN);
    const baseUrl = new URL(UP_BASE || "/uploads", chosenOrigin);
    let basePath = baseUrl.pathname.replace(/\/+$/, "");
    if (!/(\/upload(s)?)$/i.test(basePath)) basePath += "/uploads";
    return `${baseUrl.origin}${basePath}/${filePart}`;
  } catch {
    return u;
  }
}
const bust = (u, v) => (u ? `${u}${u.includes("?") ? "&" : "?"}v=${v}` : "");

/* ---- Kurumsal bilgiler (localStorage) ---- */
const readBrandInfo = (lang) => {
  let nameByLang = {};
  try {
    nameByLang = JSON.parse(
      localStorage.getItem("app_institution_by_lang") || "{}"
    );
  } catch (_) {}
  const institution =
    nameByLang?.[lang] ||
    nameByLang?.tr ||
    localStorage.getItem("app_institution_name") ||
    "Muhtar";
  const authorized =
    localStorage.getItem("app_authorized_name") || "Haymes Tasarım";
  const logo = normalizeUploadUrl(
    localStorage.getItem("app_logo_url") || "/logo192.png"
  );
  return { institution, authorized, logo };
};

/* ---- Ayarlar endpoint adayları (AyarlarPage ile tutarlı) ---- */
const SETTINGS_CANDIDATES = [
  "kurum-ayarlar",
  "kurum-ayar",
  "ayarlar",
  "settings",
];

async function fetchBrandFromAPI(lang) {
  const token = localStorage.getItem("token");
  if (!token) return null;

  const order = [localStorage.getItem("app_settings_ep")]
    .filter(Boolean)
    .concat(SETTINGS_CANDIDATES);

  for (const ep of order) {
    try {
      const res = await fetch(`${API_BASE}/${ep}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) continue;

      const json = await res.json().catch(() => ({}));
      const d = json?.data || json || {};
      const nameByLang = {
        tr: d.firma_adi_tr || "",
        en: d.firma_adi_en || "",
        de: d.firma_adi_de || "",
      };
      const institution =
        nameByLang?.[lang] || nameByLang?.tr || nameByLang?.en || "" || "Muhtar";
      const authorized = d.yetkili_adi || "";
      const logo = normalizeUploadUrl(d.logo_url || d.logo || "");

      // LocalStorage’ı da güncelle (tek firma bazlı görünüm için)
      localStorage.setItem(
        "app_institution_by_lang",
        JSON.stringify(nameByLang)
      );
      localStorage.setItem("app_institution_name", institution);
      localStorage.setItem("app_authorized_name", authorized);
      if (logo) localStorage.setItem("app_logo_url", logo);

      // Diğer bileşenler varsa haberdar olsun
      window.dispatchEvent(new Event("app_settings_change"));

      // Cache için seçilen endpoint’i hatırla
      localStorage.setItem("app_settings_ep", ep);

      return { institution, authorized, logo };
    } catch {
      // sıradakine devam
    }
  }
  return null;
}

const CustomMenu = () => {
  const navigate = useNavigate();

  // dil & marka bilgileri
  const [lang, setLang] = useState(getLang());
  const [{ institution, authorized, logo }, setBrand] = useState(
    readBrandInfo(getLang())
  );

  // Görsel önbellek kırmak için versiyon
  const [ver, setVer] = useState(0);
  const lastTokenRef = useRef(localStorage.getItem("token") || "");
// 📅 Randevu sistemi aktif mi?
const [bookingEnabled, setBookingEnabled] = useState(false);

// 🧾 Muhasebe aktif mi?
const [accountingEnabled, setAccountingEnabled] = useState(false);



  // Sunucudan marka çek (her odakta / token değişiminde)
  const loadBrand = async (reason = "init") => {
    const curToken = localStorage.getItem("token") || "";
    const tokenChanged = curToken !== lastTokenRef.current;
    if (reason === "focus" || tokenChanged || reason === "init") {
      const fromApi = await fetchBrandFromAPI(getLang());
      if (fromApi) {
        setBrand({
          institution: fromApi.institution || institution,
          authorized: fromApi.authorized || authorized,
          logo: fromApi.logo || logo,
        });
        setVer((v) => v + 1);
      } else {
        // API başarısızsa localStorage’dakini göster
        setBrand(readBrandInfo(getLang()));
        setVer((v) => v + 1);

      }
      lastTokenRef.current = curToken;
    }
  };

  useEffect(() => {
    // İlk yüklemede hem local’ı oku hem API’den zorla çek
    setBrand(readBrandInfo(getLang()));
    setVer((v) => v + 1);
    loadBrand("init");

    // Dil değişimi
    const onLang = () => {
      const l = getLang();
      setLang(l);
      // öncelikle local’i yansıt
      setBrand(readBrandInfo(l));
      setVer((v) => v + 1);
      // ardından API’den günceli al
      loadBrand("lang");
    };

    // Ayarlar değişimi (AyarlarPage kaydettiğinde tetikleniyor)
    const onSettings = () => {
      setBrand(readBrandInfo(getLang()));
      setVer((v) => v + 1);
  loadBookingFlag(); // 📅 randevu aktif mi tekrar kontrol et
  loadAccountingFlag(); // 👈 BU EKSİKTİ

    };

    // localStorage değişimleri (diğer sekmeler veya bazı akışlar)
    const onStorage = (e) => {
      if (!e || !e.key) return;
      if (["app_lang", "lang"].includes(e.key)) onLang();
      if (
        [
          "app_institution_by_lang",
          "app_institution_name",
          "app_authorized_name",
          "app_logo_url",
        ].includes(e.key)
      ) {
        onSettings();
      }
      if (e.key === "token") {
        loadBrand("token");
      }
    };

// 📅 Randevu ayarı
const loadBookingFlag = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const res = await fetch(`${API_BASE}/randevu/settings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) return;

    const data = await res.json();
setBookingEnabled(data?.data?.randevu_aktif === true);
  } catch {}
};

// 🧾 Muhasebe ayarı
const loadAccountingFlag = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    const res = await fetch(`${API_BASE}/accounting/settings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) return;

    const data = await res.json();
    setAccountingEnabled(data?.data?.accounting_aktif === true);
  } catch {}
};






loadBookingFlag();
loadAccountingFlag(); // 👈 EKLE



    // Odaklandığında güncel firmayı getir (farklı firmaya geçiş sonrası)
    const onFocus = () => loadBrand("focus");

    window.addEventListener("app_lang_change", onLang);
    window.addEventListener("app_settings_change", onSettings);
    window.addEventListener("storage", onStorage);
    window.addEventListener("focus", onFocus);
    return () => {
      window.removeEventListener("app_lang_change", onLang);
      window.removeEventListener("app_settings_change", onSettings);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", onFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoSrc = bust(logo || "/logo192.png", ver);

  return (
    <div className="h-screen w-[250px] bg-[#1f2937] text-white flex flex-col justify-between fixed left-0 top-0 shadow-lg overflow-y-auto">
      {/* ÜST: Logo + Kurum bilgisi */}
      <div className="text-center pt-20">
        <img
          src={logoSrc}
          alt="Logo"
          className="w-14 h-14 mx-auto mb-2 rounded-full shadow object-cover bg-white"
          onError={(e) => {
            e.currentTarget.src = "/logo192.png";
          }}
        />
        <p className="text-lg font-bold truncate px-4">{institution}</p>
        <div className="mt-3 text-sm bg-[#111827] py-2 px-4 rounded">
          <div className="font-semibold truncate">{authorized}</div>
        </div>
      </div>

      {/* ORTA: Menü */}
      <div className="mt-10">
        <ul className="px-6 space-y-5 text-[17px] font-medium">
          {/* 1. Anasayfa */}
          <li
            onClick={() => navigate("/")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <Home size={20} /> {t(lang, "home", "Anasayfa")}
          </li>

          {/* 2. Ana Kategoriler */}
          <li
            onClick={() => navigate("/anakategoriler")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <Layers size={20} /> {t(lang, "mainCategories", "Ana Kategoriler")}
          </li>

          {/* 3. Hakkımızda */}
          <li
            onClick={() => navigate("/bizkimiz")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <LayoutDashboard size={20} />{" "}
            {t(lang, "homepageManagement", "Hakkımızda")}
          </li>

          {/* 4. Faaliyetler */}
          <li
            onClick={() => navigate("/faaliyetler")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <Activity size={20} /> {t(lang, "activities", "Faaliyetler")}
          </li>

          {/* 5. Duyurular */}
          <li
            onClick={() => navigate("/duyurular")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <Bell size={20} /> {t(lang, "announcements", "Duyurular")}
          </li>

          {/* 6. Etkinlikler */}
          <li
            onClick={() => navigate("/etkinlikler")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <Calendar size={20} /> {t(lang, "events", "Etkinlikler")}
          </li>

{/* 📅 RANDEVULAR – sadece aktifse */}
{bookingEnabled && (
  <li
    onClick={() => navigate("/randevular")}
    className="flex items-center gap-3 
               bg-orange-600/20 hover:bg-orange-600/30 
               px-4 py-2 rounded cursor-pointer 
               text-orange-300 font-semibold"
  >
    <Calendar size={20} />
    Randevular
  </li>
)}


{/* 🧾 MUHASEBE – sadece aktifse */}
{accountingEnabled && (
  <li
    onClick={() => navigate("/muhasebe")}
    className="flex items-center gap-3 
               bg-green-600/20 hover:bg-green-600/30 
               px-4 py-2 rounded cursor-pointer 
               text-green-300 font-semibold"
  >
    <BarChart2 size={20} />
    Muhasebe
  </li>
)}



          {/* 7. İletişim */}
          <li
            onClick={() => navigate("/iletisim")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <Phone size={20} /> {t(lang, "contact", "İletişim")}
          </li>

          {/* 8. Anketler */}
          <li
            onClick={() => navigate("/anketler")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <BarChart2 size={20} /> {t(lang, "polls", "Anketler")}
          </li>



          {/* 9. Geri Bildirim */}
         {/* 9. Geri Bildirim */}
<li
  onClick={() => navigate(`/geribildirimler?lang=${lang}`)}
  className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
>
  <MessageSquare size={20} /> {t(lang, "feedback", "Geri Bildirim")}
</li>

  {/* 10. QR Kod - YENİ */}
          <li
            onClick={() => navigate("/qr-kod")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer text-orange-300 font-semibold border-l-4 border-orange-500"
          >
            <QrCode size={20} /> {t(lang, "qrCode", "QR Kod")}
          </li>


          {/* 11. Kullanıcılar */}
          <li
            onClick={() => navigate("/kullanicilar")}
            className="flex items-center gap-3 hover:bg-gray-700 px-4 py-2 rounded cursor-pointer"
          >
            <Users size={20} /> {t(lang, "users", "Kullanıcılar")}
          </li>
        </ul>
      </div>

{/* ALT: Ayarlar + Çıkış – sadece burası değişti */}
<div className="p-6 space-y-4 bg-[#1f2937] mt-10">

  {/* AYARLAR */}
  <button
    onClick={() => navigate("/ayarlar")}
    className="w-full flex items-center justify-center gap-3 
               bg-gray-700 hover:bg-gray-800 text-white 
               py-3 rounded-lg text-[17px] font-semibold transition"
  >
    <Settings size={22} />
    {t(lang, "settings", "Ayarlar")}
  </button>

  {/* DEV KIRMIZI ÇIKIŞ */}
  <button
  onClick={() => {
  localStorage.removeItem("token");

  // 🔴 eski kurum bilgilerini de temizle
  localStorage.removeItem("app_institution_by_lang");
  localStorage.removeItem("app_institution_name");
  localStorage.removeItem("app_authorized_name");
  localStorage.removeItem("app_logo_url");
  localStorage.removeItem("app_settings_ep");

  window.location.reload();
}}




    className="w-full flex items-center justify-center gap-3 
               bg-red-600 hover:bg-red-700 text-white 
               py-6 rounded-xl text-[20px] font-bold 
               transition shadow-lg tracking-wide"
  >
    <LogOut size={28} />
    {t(lang, "logout", "Çıkış")}
  </button>

</div>




    </div>
  );
};

export default CustomMenu;
